/* src/app/auth/company-access-dialog/company-access-dialog.component.scss */
/*# sourceMappingURL=company-access-dialog.component.css.map */
